<!--
Author: TangChen
Date: 2018-09-19
Desc: 协议内容
-->
<template>
    <div class="comp-agreement comp">
        <el-checkbox name="type">
            <div class="agree-list clear">
                <b>我已阅读并同意</b>
                <span v-for="item of protocol" :key="item.id" v-on:click.prevent="agreementCon(item)">《{{ item.title }}》</span>
            </div>
        </el-checkbox>
        <el-dialog :title="agrCon.title" :visible.sync="centerDialogVisible" :fullscreen="isFullscreen" :center="true">
            <div style="text-align:left" v-html="agrCon.content" />
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" v-on:click="centerDialogVisible = false">
                    我已知晓
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "Agreement",
    props: {
        data: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            protocol: [],
            centerDialogVisible: false,
            agrCon: {},
            isFullscreen: false
        };
    },
    mounted () {
        this.getAgreement();
    },
    methods: {
        // 查询具体合同内容
        agreementCon (val) {
            let _this = this;
            const _data = {
                id: val.id,
                version: val.version
            };
            this.$util.request("common/protocol/content", _data).then(res => {
                if (res.data) {
                    const con = res.data[0];
                    if (con) {
                        _this.agrCon = con;
                        _this.centerDialogVisible = true;
                    }
                }
            });
        },
        getAgreement () {
            let _this = this;
            this.$util.getProtocol(this.data).then(res => {
                _this.protocol = res;
                let _info = "";
                for (let pro of _this.protocol) {
                    _info += "、《" + pro.title + "》";
                }
                _this.$emit("protocol", _info.substring(1));
            });
        }
    }
};
</script>
<style lang="scss">
    .comp-agreement {
        width: 100%;
        .el-checkbox__input {
            vertical-align: top;
        }
        .el-checkbox__label {
            line-height:24px;
            cursor: default;
            vertical-align: top;
            .agree-list{display: inline-block;vertical-align: top;line-height: 24px;}
            b{
                float: left;
                line-height: 20px;
                font-weight: normal;
            }
            span {
                cursor: pointer;
                line-height: 20px;
                display: inline-block;
                float: left;
                &:after {
                    content: "、";
                }
                &:last-child:after {
                    content: "";
                }
            }
        }
        .dialog-footer{
            text-align: center;
        }
    }
</style>
